export default {
  name: 'Header'
};